// src/stores/user.js
import { defineStore } from "pinia";
import { ref } from "vue";
import { userApi, postApi } from "@/api";
import { showToast, showLoadingToast, closeToast } from 'vant'
import { jwtDecode } from 'jwt-decode';
import router from "@/router";

export const useUserStore = defineStore("user", () => {
  // 状态
  const userInfo = ref({
    _id: "",
    username: "",
    nickname: "",
    avatar: "",
    token: "",
    isAdmin: false,
  });
  


  // 用户发布的帖子列表状态
  const userPosts = ref({
    list: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    hasInitialized: false,
  });
  // 获取本地存储的用户信息
  const initUserInfo = () => {
    const storedInfo = localStorage.getItem("userInfo");
    if (storedInfo) {
      userInfo.value = JSON.parse(storedInfo);
    }
  };

  // 设置用户信息
  const setUserInfo = (info) => {
    userInfo.value = info;
    // 存储到本地
    localStorage.setItem("userInfo", JSON.stringify(info));
    // 单独存储 token，方便请求拦截器使用
    localStorage.setItem("token", info.token);
  };

  // 更新用户部分信息
  const updateUserInfo = (info) => {
    userInfo.value = {
      ...userInfo.value,
      ...info,
    };
    localStorage.setItem("userInfo", JSON.stringify(userInfo.value));
  };

  // 清除用户信息
  const clearUserInfo = () => {
    userInfo.value = {
      _id: "",
      username: "",
      nickname: "",
      avatar: "",
      token: "",
    };
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
  };

  // 判断是否登录
  const isLoggedIn = () => {
    return !!userInfo.value.token;
  };

  // 获取用户发布的帖子列表
  const getUserPosts = async (page = 1, pageSize = 10) => {
    try {
      const params = {
        page,
        pageSize,
        category: "all",
        userId: userInfo.value._id,
      };
      const response = await postApi.getList(params);
      // console.log(response);

      userPosts.value = {
        list: page === 1 ? response.posts : [...userPosts.value.list, ...response.posts],
        total: response.total,
        currentPage: response.currentPage,
        pageSize: response.pageSize,
        hasInitialized: true,
      };
      return response;
    } catch (error) {
      console.error("获取用户帖子列表失败:", error);
      throw error;
    }
  };
  // 清除用户帖子列表
  const clearUserPosts = () => {
    userPosts.value = {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
    };
  };
  // 添加退出登录方法
  const logout = async () => {
    try {
      // 先清除本地状态，确保用户可以退出
      clearUserInfo()

      // 调用退出登录接口
      await userApi.logout()

      // 跳转到首页
      router.push("/")

      // 显示成功提示
      showToast({
        message: '退出登录成功',
        type: 'success'
      })
    } catch (error) {
      console.error("退出登录失败:", error);
      // 已经清除了本地状态，所以继续跳转
      router.push("/");
    }
  };

  return {
    userInfo,
    setUserInfo,
    updateUserInfo,
    clearUserInfo,
    initUserInfo,
    isLoggedIn,
    logout,
    userPosts,
    getUserPosts,
    clearUserPosts,
  };
});
